import { Meeting, MeetingAttachment } from "../../interfaces/Meeting";
import moment from "moment";
import { SettingMultiMeetings, SettingMultiMerchants, SettingMultiPipelines, Settings } from "../../interfaces/Settings";
import { ExpandableElement } from "./ExpandableElement";
import { Tooltip } from 'react-tippy';
import { Link } from "react-router-dom";
import { OverlayTrigger } from "react-bootstrap";
import { Merchant } from "../../interfaces/Merchant";
import { KTSVG, toAbsoluteUrl } from "../../_metronic/helpers";
import { ListProduct, Pipeline } from "../../interfaces";
import { currencyFormatter, customThousandSeparatorDot, isColorDarkFromHex } from "../../functions/general";
import BadgeTooltip from "./BadgeTooltip";
import { Reimburse } from "../../interfaces/Reimbursement";
import IconTooltip from "./IconTooltip";
import { checkIsCompanyTanrise, checkIsNewProgress } from "../../functions/customCase";
import { CustomeStoreCompanyIdProps } from "../../stores/CustomeStore";
import { UserModel } from "../../app/modules/auth/models/UserModel";
import LabelTooltip from "./LabelTooltip";

interface IProducLabelMerge {
    text: string
    color: string
}

interface IProductLabelAcc {
    [key: string]: {
        productLabelColor: string;
        productLabelName: string;
        productSName: string[];
    };
}


export const returnCustomFieldPipeline = (idTemplate: string, idPipeline: string, name: string) => {
    return (
        <a href={`/pipelines/${idTemplate}/log/${idPipeline}`} target="_blank" rel="noopener noreferrer">{name}</a>
    )
}

export const returnCustomFieldMerchant = (data: any) => {
    return (
        <Link
            to={"/merchants/" + data.merchant_template_id + "/detail/" + data.merchant_id}
            target='_blank'
        >
            {data.merchant_name}
        </Link>
    )
}

export const returnCustomFieldMeeting = (data: any) => {
    return (
        <Link
            to={"/meetings/" + data.meeting_template_id + "/detail/" + data.id}
            target='_blank'
        >
            {`${data.merchant_name} / ${moment(data.dateMeet).utc(true).format('DD MMM YYYY')} / ${data.meeting_status}`}
        </Link>
    )
}

export const returnImage = (url: string | string[] | MeetingAttachment[], intl: any) => {
    if (Array.isArray(url)) {
        return (url as MeetingAttachment[] | string[]).map((data: MeetingAttachment | string, index: number) => (
            <span key={index}>
                <a href={(data as MeetingAttachment).url ? (data as MeetingAttachment).url as string : data as string} target="_blank" rel="noopener noreferrer">{intl.formatMessage({ id: "FORM.ACTION.VIEW_PICTURE" })} {index + 1}</a>
                {index < url.length - 1 && ', '}
            </span>
        ));
    } else {
        return (
            <a href={url} target="_blank" rel="noopener noreferrer">{intl.formatMessage({ id: "FORM.ACTION.VIEW_PICTURE" })}</a>
        );
    }
};

export const returnFile = (url: string | string[], intl: any) => {
    if (Array.isArray(url)) {
        return url.map((data: string, index: number) => (
            <span key={index}>
                <a href={data} target="_blank" rel="noopener noreferrer">{intl.formatMessage({ id: "FORM.ACTION.VIEW_FILE" })} {index + 1}</a>
                {index < url.length - 1 && ', '}
            </span>
        ));
    } else {
        return (
            <a href={url} target="_blank" rel="noopener noreferrer">{intl.formatMessage({ id: "FORM.ACTION.VIEW_FILE" })}</a>
        );
    }
};

export const returnMultiple = (data: string) => {
    const values = data && data.toString()
    return values ? values.split(',').join(', ') : '-'
}

export const returnOption = (data: string) => {
    return (
        <div style={{ whiteSpace: 'pre-wrap' }}>
            <div>{data}</div>
        </div>
    )
}

export const returnParagraph = (data: string) => {
    return (
        <ExpandableElement text={(data).replaceAll('\n', '<br/>')} maxHeight={100} />
    )
}

export const returnLink = (data: string) => {
    return (
        <a href={data} rel="noreferrer" className="btn btn-sm btn-outline btn-outline-default btn-active-light text-gray-600" target="_blank">Lihat<i className="fas fa-external-link-alt fs-6 ms-2 p-0"></i></a>
    )
}




// ================ PIPELINE ================
export const returnMerchantNamePipeline = (data: Pipeline) => {
    switch (data.hot_warm_cold_status) {
        case 'hot':
            return (
                <div className="d-flex align-items-center">
                    <div>
                        <span>{data.merchant_name}</span>
                        {data.merchant_link && <p style={{ color: "#a1a5b7", marginBottom: '0px', fontStyle: 'italic' }}>{data.merchant_link.merchantName}</p>}
                    </div>
                    <span className="badge badge-light-danger ms-3">Hot</span>
                </div>
            )
        case 'warm':
            return (
                <div className="d-flex align-items-center">
                    <div>
                        <span>{data.merchant_name}</span>
                        {data.merchant_link && <p style={{ color: "#a1a5b7", marginBottom: '0px', fontStyle: 'italic' }}>{data.merchant_link.merchantName}</p>}
                    </div>
                    <span className="badge badge-light-warning ms-3">Warm</span>
                </div>
            )
        case 'cold':
            return (
                <div className="d-flex align-items-center">
                    <div>
                        <span>{data.merchant_name}</span>
                        {data.merchant_link && <p style={{ color: "#a1a5b7", marginBottom: '0px', fontStyle: 'italic' }}>{data.merchant_link.merchantName}</p>}
                    </div>
                    <span className="badge badge-light-primary ms-3">Cold</span>
                </div>
            )
        default:
            return data.merchant_name
    }
}

export const returnLabel = (data: Pipeline) => {
    var labels = data?.labels?.map((label: any) => ({ text: label.name, color: label.color })) || [];

    return (
        <>
            {
                labels.length > 0 ? (
                    <LabelTooltip data={labels}>
                        {labels}
                    </LabelTooltip>
                ) : "-"
            }
        </>
    )
}

export const returnProgress = (data: Pipeline, intl: any, companyId: CustomeStoreCompanyIdProps, user: UserModel) => {
    const progressName = data.lead_progress_name;
    const subProgressName = data.lead_subprogress_name;
    const progressColor = data.lead_progress_color;

    const newProgress = checkIsCompanyTanrise(companyId, user) ? intl.formatMessage({ id: "FORM.LABEL.CONTACTED" }) : intl.formatMessage({ id: "FORM.LABEL.NEW" })
    const badgeContent = checkIsNewProgress(progressName) ? newProgress : subProgressName ? `${progressName} (${subProgressName})` : progressName;


    const badgeStyle = progressColor
        ? { backgroundColor: progressColor, color: isColorDarkFromHex(progressColor) ? "white" : "black" }
        : {};

    return (
        <div className="d-flex gap-2 align-items-center">
            <BadgeTooltip tooltipText={badgeContent} badgeClass={progressColor ? '' : 'badge-light-info'} style={badgeStyle}>
                {badgeContent}
            </BadgeTooltip>
            {data.has_pending_log && (
                <IconTooltip tooltipText={intl.formatMessage({ id: "FORM.LABEL.PENDING_LOG" })}>
                    {<i className="fas fa-info-circle text-warning fs-5"></i>}
                </IconTooltip>
            )}
        </div>
    );
}

export const returnProductName = (productsName: string[]) => {
    return productsName.map((name, index) => index !== 0 ? `, ${name}` : name)
}

export const returnProduct = (data: Pipeline, setShowDetailProductModal?: any) => {
    const labels: IProducLabelMerge[] = data.leadProducts.flatMap((leadProduct) =>
        leadProduct.productLabels?.map((productLabel) => ({
            text: productLabel.name,
            color: productLabel.color,
        })) || []
    );

    return (
        <div className="d-flex gap-2">
            {
                setShowDetailProductModal ?
                    <div className="text-primary cursor-pointer" onClick={() => { setShowDetailProductModal(true) }} dangerouslySetInnerHTML={{ __html: data.leadProducts?.map((dataProduct: ListProduct) => dataProduct.productName).join(', ') }} />
                    :
                    <div dangerouslySetInnerHTML={{ __html: data.leadProducts?.map((dataProduct: ListProduct) => dataProduct.productName).join(', ') }} />
            }

            {
                labels.length > 0 ? (
                    <LabelTooltip data={labels}>
                        {labels}
                    </LabelTooltip>
                ) : "-"
            }
        </div>
    )
}

export const returnQtyProduct = (data: Pipeline) => {
    if (data.leadProducts) return customThousandSeparatorDot(data.leadProducts?.reduce((total, dataProduct) => total + Number(dataProduct.leadProductQty), 0))
    else return 0
}

export const returnSource = (data: Pipeline) => {
    let badgeText = data.lead_source_name;
    let badgeClass = 'badge-light-info'; // Default class

    // Tentukan badgeClass dan badgeText berdasarkan source name
    switch (data.lead_source_name) {
        case 'INBOUND':
            badgeClass = 'badge-light-primary';
            badgeText = 'Inbound';
            break;
        case 'OUTBOUND':
            badgeClass = 'badge-light-success';
            badgeText = 'Outbound';
            break;
        default:
            break;
    }

    // Gunakan BadgeTooltip untuk menampilkan tooltip pada badge
    return (
        <BadgeTooltip tooltipText={badgeText} badgeClass={badgeClass}>
            {badgeText}
        </BadgeTooltip>
    );
};

export const returnInvoiceReminder = (url: string, date: string, intl: any) => {
    return (
        <div>
            {moment(date).format("DD MMM YYYY")}, <a href={url} target="_blank" rel="noopener noreferrer">{intl.formatMessage({ id: "FORM.ACTION.VIEW_INVOICE" })}</a>
        </div>
    )
}





// ================ MEETING ================
export const returnStatusMeeting = (data: Meeting, intl: any) => {
    if (data.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.SCHEDULED' })) {
        return <span className="badge badge-scheduled" >{data.meeting_status}</span>
    } else if (data.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' })) {
        return <span className="badge badge-done" >{data.meeting_status}</span>
    } else if (data.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.ONGOING' })) {
        return <span className="badge badge-ongoing" >{data.meeting_status}</span>
    } else if (data.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.PENDING' })) {
        return <span className="badge badge-pending" >{data.meeting_status}</span>
    } else if (data.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.APPROVED' })) {
        return <span className="badge badge-approved" >{data.meeting_status}</span>
    } else if (data.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.REJECTED' })) {
        return <span className="badge badge-rejected" >{data.meeting_status}</span>
    } else {
        return (
            <>
                {
                    (data.meetingStatusNote)?.includes("sistem") ?
                        <Tooltip
                            title={`${intl.formatMessage({ id: 'TOOLTIP.AUTO_CANCEL_SYSTEM' })}`}
                            theme="light"
                            arrow={true}
                            style={{ cursor: "default", display: "flex", alignItems: "center", width: "min-content" }}
                        >
                            <span className="badge badge-cancelled" >{intl.formatMessage({ id: 'MEETING.STATUS.CANCELLED' })}</span>
                            <i className='fas fa-info-circle ms-2 fs-7'></i>
                        </Tooltip>
                        :
                        <span className="badge badge-cancelled" >{intl.formatMessage({ id: 'MEETING.STATUS.CANCELLED' })}</span>
                }
            </>
        )
    }
};

export const returnMerchantNameMeeting = (row: Meeting, selectMultiMeeting: SettingMultiMeetings, intl: any) => {
    var labels = row?.labels?.map((label: any) => ({ text: label.name, color: label.color })) || [];

    if (row.type === "VISIT") {
        return (
            <div className="d-flex flex-row gap-2">
                <div>
                    <span>{row.merchant_name}</span>
                    <span className="badge badge-light-primary ms-3" >{intl.formatMessage({ id: 'MEETING.STATUS.VISIT' })}</span>
                </div>
                {selectMultiMeeting.isFeatureLabelEnabled && labels.length > 0 && (
                    <LabelTooltip data={labels}>
                        {labels}
                    </LabelTooltip>
                )}
            </div>
        )
    } else {
        return (<div className="d-flex flex-row gap-2">
            <div>
                {row.merchant_name}
            </div>
            {selectMultiMeeting.isFeatureLabelEnabled && labels.length > 0 && (
                <LabelTooltip data={labels}>
                    {labels}
                </LabelTooltip>
            )}
        </div>
        )
    }
}

export const returnTypeMeeting = (row: Meeting, settings: Settings, intl: any) => {
    if (row.type === 'MEETING') return intl.formatMessage({ id: 'MEETING.TYPE.MEETING' }, { title: settings.meeting_title })
    else if (row.type === 'SCHEDULED_MEETING') return intl.formatMessage({ id: 'MEETING.TYPE.SCHEDULED_MEETING' }, { title: settings.meeting_title })
    else if (row.type === 'VISIT') return intl.formatMessage({ id: 'MEETING.TYPE.VISIT' })
    else if (row.type === 'SCHEDULED_VISIT') return intl.formatMessage({ id: 'MEETING.TYPE.SCHEDULED_VISIT' })
    else return "-"
}



// ================ MERCHANT ================
export const returnMerchantNameMerchant = (row: Merchant, selectMultiMerchant: SettingMultiMerchants) => {
    var labels = row?.labels?.map((label: any) => ({ text: label.name, color: label.color })) || [];

    return (
        <div className="d-flex flex-row gap-2">
            <div>
                <span>{row.name}</span>
            </div>
            {selectMultiMerchant.isFeatureLabelEnabled && labels.length > 0 && (
                <LabelTooltip data={labels}>
                    {labels}
                </LabelTooltip>
            )}
        </div>
    )
}

export const returnWhatsapp = (data: Merchant) => {
    if (data.isWhatsappPhone) return <img alt='Banner' style={{ width: "15px", height: "15px" }} src={toAbsoluteUrl('/media/assets/checked.png')} />
    else return <img alt='Banner' style={{ width: "15px", height: "15px" }} src={toAbsoluteUrl('/media/assets/remove.png')} />
};

export const returnPipelineCount = (data: Merchant, multiPipelines: SettingMultiPipelines[]) => {
    if (multiPipelines.length > 0) {
        return (
            <Link to={`/merchants/${data.merchantTemplateId}/${data.id}/pipelines/${multiPipelines[0].id}`} target="_blank" className="text-black">
                <span className="cursor-pointer text-primary">{data.leadsCount}</span>
            </Link>
        )
    } else {
        return <span>{data.leadsCount}</span>
    }
}

export const returnMeetingCount = (data: Merchant, multiMeetings: SettingMultiMeetings[]) => {
    if (multiMeetings.length > 0) {
        return (
            <Link to={`/merchants/${data.merchantTemplateId}/${data.id}/meetings/${multiMeetings[0].id}`} target="_blank" className="text-black">
                <span className="cursor-pointer text-primary">{data.meetingsCount}</span>
            </Link>
        )
    } else {
        return <span>{data.meetingsCount}</span>
    }
}


// ================ REIMBURSEMENT ================
export const returnReimbursementCategory = (data: Reimburse) => {
    if (data.reimbursementCategory.color) {
        return (
            <span className="badge" style={{ backgroundColor: data.reimbursementCategory.color, color: isColorDarkFromHex(data.reimbursementCategory.color) ? "white" : "black" }}>{data.reimbursementCategory.name}</span>
        )
    } else {
        return (
            <span className="badge badge-light-info" >{data.reimbursementCategory.name}</span>
        )
    }
}

export const returnExpenseNominal = (data: Reimburse) => {
    if (data.companyCurrency.code === "USD") {
        return <div className="input-group mb-4">{currencyFormatter(data.value, false, "USD", { showPrefix: true })}</div>
    } else {
        return <div className="input-group mb-4">{currencyFormatter(data.value, true, "IDR", { showPrefix: true })}</div>
    }
}

export const returnReference = (data: Reimburse, handleClickDetail: (type: string) => void) => {
    return (
        <div className="cursor-pointer input-group mb-4 d-flex align-items-center gap-1 text-primary" onClick={() => handleClickDetail(data.reference.type)}>
            {data.reference.type === 'MEETING' ? data.reference.meeting.merchant_name + ' - ' + moment(data.reference.meeting.date_meet).format('DD MMMM YYYY') : data.reference.merchant.name}
            <KTSVG path="/media/icons/duotune/arrows/arr095.svg" className='svg-icon-5 svg-icon-primary' />
        </div>
    )
}

